import React, {useEffect, useState} from "react";
import { makeAPI } from "../services/api";
import ProductCard from "../components/store/product_card";
import CouponPreview from "../components/store/product_preview";

export default function Store() {
    const [products, setProducts] = useState([]);
    const [categories, setCategories] = useState([]);
    const [filter, setFilter] = useState({});
    const [limit] = useState(15);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(false);
    const [min_price, setMinPrice] = useState(0);
    const [max_price, setMaxPrice] = useState(0);
    const [isCouponPopupOpen, setIsCouponPopupOpen] = useState(false);
    const [couponData, setSelectedCoupon] = useState();

    const fetchProducts = async (pageNum) => {
        if (loading || (!hasMore && pageNum !== 1)) return;

        setLoading(true);
        if (pageNum === 1) setProducts([]);

        try {
            let payload = {
                min_price: min_price,
                max_price: max_price,
                filter_data: filter,
                limit: limit,
                page: pageNum
            };

            const response = await makeAPI('/api/get_products', "POST", false, payload);

            if (response.products.length === 0) {
                setHasMore(false);
            } else {
                setHasMore(true);
                setProducts(prev => pageNum === 1 ? response.products : [...prev, ...response.products]);
                setPage(pageNum + 1);
                setCategories(response.filter.catagory_data);
                setMinPrice(response.filter.min_price);
                setMaxPrice(response.filter.max_price);
                setTimeout(() => {
                    $(".js-select").niceSelect("destroy");
                    $(".js-select").niceSelect();
                }, 100);
            }
        } catch (error) {
            console.error('Error fetching products:', error);
        }

        setLoading(false);
    };

    React.useEffect(() => {
        const handler = function (e) {
            const $select = $(e.target);
            const value = $select.val();
            const type = $select.data("type");

            if (type === "sortby") {
                setFilter(prev => ({ ...prev, sortby: value }));
                setPage(1);
            }

            if (type === "category") {
                setFilter(prev => ({ ...prev, catagory_fliter: [value] }));
                setPage(1);
            }

            if (type === "filter_type") {
                setFilter(prev => ({ ...prev, filter_type: [value] }));
                setPage(1);
            }
        };

        $(document).on("change", "select.js-select", handler);
        return () => {
            $(document).off("change", "select.js-select", handler);
        };
    }, []);

    React.useEffect(() => {
        document.title = "Store - CGES.CLUB";
        setPage(1);
        setHasMore(true);
        fetchProducts(1);
    }, [filter]);

    async function search_listener(e) {
        let target_value = e.target.value;
        filter.search = target_value.trim();
        if (target_value.length >= 3 || target_value.length === 0) {
            setPage(1);
            setHasMore(true);
            await fetchProducts(1);
        }
    }

    const handleRedeemClick = (couponData) => {
        setSelectedCoupon(couponData);
        setIsCouponPopupOpen(true);
    };

    return (
        <>
            <style>{`
            /* Target nice-select dropdown list */
                .nice-select .list {
                max-height: 400px !important;
                overflow-y: auto !important;

                }
                body.dark-theme .nice-select .list {
                background:#000000;
                        }

                /* Optional: make scrollbar smooth */
                .nice-select .list::-webkit-scrollbar {
                width: 6px;
                }

                .nice-select .list::-webkit-scrollbar-thumb {
                background: #161616;
                border-radius: 10px;
                }

         `} </style>

            {isCouponPopupOpen && (
                <CouponPreview couponData={couponData} onClose={() => setIsCouponPopupOpen(false)} />
            )}
            <div className="widjet --filters">
                <h3 className="uk-text-lead">Store</h3>
                <div className="widjet__body">
                    <div className="uk-grid uk-child-width-1-6@xl uk-child-width-1-3@l uk-child-width-1-2@s uk-flex-middle uk-grid-small" data-uk-grid>
                        <div className="uk-width-1-1">
                            <div className="search">
                                <div className="search__input"><i className="ico_search"></i><input type="search" name="search" placeholder="Search" onChange={(e) => {
                                    search_listener(e);
                                }
                                } /></div>
                            </div>
                        </div>
                        <div><select className="js-select" data-type="sortby">
                            <option value="">Sort By: All</option>
                            <option value="date">Sort by : Recently added</option>
                            <option value="min">Sort by : Price Low</option>
                            <option value="max">Sort by : Price High</option>
                        </select></div>
                        <div>
                            <select className="js-select" style={{ maxHeight: '400px' }} data-type="category">

                                <option value="">Category: All </option>

                                {categories && categories.map((data) => (
                                    <option key={data.categories} value={data.categories}>{data.categories}</option>
                                ))}
                            </select>
                        </div>
                        <div><select className="js-select" data-type="filter_type">
                            <option value="All">Type: All</option>
                            <option value="Coupons">Coupons</option>
                            <option value="Gift Cards">Gift Cards</option>
                        </select></div>
                        {/* <div><select className="js-select">
                            <option value=""># of Players: All</option>
                            <option value="Platform 1">Platform 1</option>
                            <option value="Platform 2">Platform 2</option>
                            <option value="Platform 3">Platform 3</option>
                        </select></div> */}
                        {/* <div>
                            <div className="price-range"><label>Price</label><input className="uk-range" type="range" min={min_price} max={max_price} step={10} /></div>
                        </div> */}
                        {/* <div className="uk-text-right">{products.length} items</div> */}
                    </div>
                </div>
            </div>
            <div className="uk-grid uk-child-width-1-5@xl uk-child-width-1-4@l uk-child-width-1-3@s uk-flex-middle uk-grid-small" data-uk-grid>
                {products.length === 0 && !loading && <p>No products available at the moment.</p>}
                {products.map((product, index) => (
                    <ProductCard key={index} product_data={product} onRedeem={handleRedeemClick} />
                ))}
                {loading && <p>Loading...</p>}
                {!loading && hasMore && products.length >= limit && (
                    <div className="uk-width-1-1 uk-text-center uk-margin-top">
                        <a
                            href="#"
                            style={{ textDecoration: 'underline' }}
                            onClick={(e) => {
                                e.preventDefault();
                                fetchProducts(page);
                            }}
                        >
                            Load more
                        </a>
                    </div>
                )}
            </div>
        </>
    );
}
